var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"steps"},_vm._l((_vm.steps),function(step,index){return _c('div',{key:index,class:['step-item', _vm.currentStep >= index ? 'active' : '', _vm.currentStep > index ? 'active-line' : '']},[_c('span',{class:['icon', step.icon]}),_c('p',[_vm._v(_vm._s(step.title))]),_c('i',{staticClass:"line"})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }